// Search → "Seasons & events": open a month, and optionally one event in it.
// The section is lazy-loaded, so the request is also kept until it mounts.

export type EventRequest = { month: number; title?: string };

export const OPEN_EVENT = 'corazon:open-event';

let pending: EventRequest | null = null;

export const requestEvent = (request: EventRequest) => {
  pending = request;
  window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: request }));
};

export const takePendingEvent = (): EventRequest | null => {
  const request = pending;
  pending = null;
  return request;
};
